import { createApp } from 'vue'
import App from './App.vue'
import http from "@/http";
import VueAxios from 'vue-axios'
import {getApi} from "@/getApi";
import ConfigsError from "@/components/configs-error.vue";
import AnalyticsPlugin from './analytics';

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
getApi(params.business_id).then((tenantResponse) => {
    if(tenantResponse && tenantResponse.api_url){
        http.defaults.baseURL = tenantResponse.api_url;
        const app = createApp(App, {
            tenantName: tenantResponse.tenant_name
        })
        app.config.globalProperties.businessId = tenantResponse.restaurant_id;
        app.use(VueAxios, http)
        app.use(AnalyticsPlugin);
        app.mount('#app')
    }else{
        const app = createApp(ConfigsError)
        app.use(VueAxios, http)
        app.mount('#app')
    }
});
